import React from 'react';
import '../styles/Logo.css';

const Logo = ({ size = 'medium', onClick }) => {
  return (
    <div 
      className={`logo-container logo-${size}`}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <img 
        src="./copia(1).png" 
        alt="ATHACADO 68 Distribuidora" 
        className="logo-image"
      />
    </div>
  );
};

export default Logo;
